module.exports = __webpack_public_path__ + "static/media/social-windows.128b065e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/avatars/social-windows.svg
// module id = 129
// module chunks = 0